import styled from "@emotion/styled";

export const PicturesContainer = styled.div`
    width: 100%;
    margin: 2rem auto;
    display: flex;
    justify-content: center;
    gap: 2rem;
    flex-wrap: wrap;
`;

export const Picture = styled.img`
    width: 100%;
    max-width: 500px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    object-fit: cover;
`;


export const WidePictureContainer = styled.div`
    width: 100%;
    margin: 2rem 0;
`;

export const StyledWidePicture = styled.img`
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
    object-fit: cover;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;
